import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import { VtmnButtonSizeEnum } from '~/component/buttons/vtmn-button/enum/vtmn-button-size.enum';
import { VtmnButtonVariantEnum } from '~/component/buttons/vtmn-button/enum/vtmn-button-variant.enum';

@Component({
  selector: 'app-horizontal-card',
  templateUrl: './horizontal-card.component.html',
  styleUrls: ['./horizontal-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HorizontalCardComponent {
  @Input() public dataEmitClick?;
  @Input() public description: string;
  @Input() public href?: string;
  @Input() public image: string;
  @Input() public title: string;

  @Output() public readonly clicked = new EventEmitter<void>();

  public readonly vtmnButtonSize = VtmnButtonSizeEnum;
  public readonly vtmnButtonVariant = VtmnButtonVariantEnum;

  public get hasEmit(): boolean {
    return !this.href;
  }

  public click(): void {
    return this.clicked.emit(this.dataEmitClick);
  }
}
